<template lang="pug">

  section.hero
    .hero-body
      .container
        //- img.logo(v-bind:src="logo", alt="logo")
        img.logo(src="/static/logo.png", alt="logo")
        h2.subtitle Self Service
        
  
</template>

<script>
  export default {
    name: 'welcome',
    data () {
      return {
        empresa: process.env.EMPRESA,
        empresa_full: process.env.EMPRESA_FULL
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>

  $yellow = #ffdd57
  $blue = #2366d1

  .logo 
    width 350px
    margin-top 10px

  .hero
    margin-bottom 10px  
  

</style>



// WEBPACK FOOTER //
// Header_Not_Logged.vue?299f8489